import { ENDPOINT } from '../../constants/server/api';
import { fetchApiData } from '../../utils/apiUtils';

export const createBranchTag = (businessSlug, branchId, branchTagData) => async dispatch => {
  const data = await fetchApiData({
    method: 'post',
    endpoint: `bo/${businessSlug}/${ENDPOINT.BRANCH_TAG}??branchId=${branchId}`,
    data: branchTagData,
    headers: {
      'Content-Type': 'application/json'
    },
    dispatch
  });

  if (data) {
    return data;
  }
};

export const getBranchTagById = (businessSlug, id) => async dispatch => {
  const data = await fetchApiData({
    method: 'get',
    endpoint: `bo/${businessSlug}/${ENDPOINT.BRANCH_TAG}/${id}`,
    dispatch
  });

  if (data) {
    return data;
  }
};

export const getBranchTagPaginationList = params => async dispatch => {
  const { businessSlug, branchId, page = 1, per_page = 10, s = '', sortBy = 'created_at', sortOrder = 'desc' } = params;

  const data = await fetchApiData({
    method: 'get',
    endpoint: `bo/${businessSlug}/${ENDPOINT.BRANCH_TAG}/pagination/list`,
    params: {
      businessSlug,
      branchId,
      page,
      perPage: per_page,
      s,
      sortBy,
      sortOrder
    },
    dispatch
  });

  if (data) {
    return data;
  }
};

export const getBranchTagAllList = (businessSlug, branchId) => async dispatch => {
  const data = await fetchApiData({
    method: 'get',
    endpoint: `bo/${businessSlug}/${ENDPOINT.BRANCH_TAG}/all/list`,
    params: {
      businessSlug,
      branchId
    },
    dispatch
  });

  if (data) {
    return data;
  }
};

export const updateBranchTag = (businessSlug, id, branchTagData) => async dispatch => {
  const data = await fetchApiData({
    method: 'put',
    endpoint: `bo/${businessSlug}/${ENDPOINT.BRANCH_TAG}/${id}`,
    data: branchTagData,
    headers: {
      'Content-Type': 'application/json'
    },
    dispatch
  });

  if (data) {
    return data;
  }
};

export const deleteBranchTag = (businessSlug, id) => async dispatch => {
  const data = await fetchApiData({
    method: 'delete',
    endpoint: `bo/${businessSlug}/${ENDPOINT.BRANCH_TAG}/${id}`,
    dispatch
  });

  if (data) {
    return data;
  }
};

export const exportBranchTagToExcel = (businessSlug, branchId, searchTerm) => async dispatch => {
  const data = await fetchApiData({
    method: 'post',
    endpoint: `bo/${businessSlug}/${ENDPOINT.BRANCH_TAG}/excel`,
    params: {
      businessSlug,
      branchId,
      s: searchTerm || ''
    },
    responseType: 'blob',
    dispatch
  });

  if (data) {
    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'รายการแท็กสาขา.xlsx');
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  }
};
